import { SortFilter } from "./pagination";

const isSortFilter = (object?: any): object is SortFilter => object?.discriminator === "SortFilter";

const isSortFilterArray = (object?: any): object is SortFilter[] => {
  return object && Array.isArray(object) && object.every(isSortFilter);
};

export { isSortFilter, isSortFilterArray };
